<template>
  <div v-if="showStandardModelRemainingQuota" class="quota-option">
    <div class="quota-option__label">
      <span>残り回数</span>
    </div>
    <div class="quota-option__value">
      <span class="quota-option__value__remaining">{{ standardModelRemainingQuota }}</span>
      <span class="quota-option__value__slash" />
      <span class="quota-option__value__allocated">{{ allocatedQuota }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '@/plugins/auth';
import { useStore } from '@/store/useStore';
import { computed, defineExpose } from 'vue';

const store = useStore();
const auth = useAuth();
const plan = auth.user.labsWandhPlan;

const showStandardModelRemainingQuota = !!plan && plan.maxSearchTotal !== null;

const quota = computed(() => {
  return store.state.persistent.labs.wandh.quota;
});

const standardModelRemainingQuota = computed((): string => {
  return quota.value?.remainingQuotaByModel.standard.remainingQuota?.toLocaleString() ?? '0';
});

const allocatedQuota = computed((): string => {
  return auth.user.labsWandhPlan?.maxSearchTotal?.toLocaleString() ?? '0';
});

const hasRemainingQuota = computed(() => {
  return (
    // nullの場合は無制限なので常にtrue
    (!!plan && plan.maxSearchTotal === null) ||
    (quota.value &&
      quota.value?.remainingQuotaByModel.standard.remainingQuota !== null &&
      quota.value?.remainingQuotaByModel.standard.remainingQuota > 0)
  );
});

defineExpose({
  hasRemainingQuota,
});
</script>

<style lang="scss" src="./quota-option.scss" scoped />
